export default "__VITE_ASSET__4t2wToPT__"